import { MaterialType } from "../../../types/materials";
import { EventsFiltersForm, EventsTimeInterval, EventType } from "../../events/types";
import { otherMaterial } from "../../forms/forms-fields/materials-form-fields";

export const FORM_DEFAULT_VALUES = {
  timeInterval: EventsTimeInterval.FUTURE_EVENTS,
  eventType: {
    [EventType.DIGITAL]: false,
    [EventType.IN_PERSON]: false,
  },
  search: "",
  country: "",
  materials: {
    [MaterialType.Wood]: false,
    [MaterialType.Stone]: false,
    [MaterialType.Glass]: false,
    [MaterialType.Materia]: false,
    [MaterialType.Metal]: false,
    [otherMaterial]: false,
  },
} as const satisfies EventsFiltersForm;
